import { render, staticRenderFns } from "./WBtnLaunch.vue?vue&type=template&id=5de887b2&scoped=true&"
import script from "./WBtnLaunch.vue?vue&type=script&lang=js&"
export * from "./WBtnLaunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de887b2",
  null
  
)

export default component.exports